import { createReducer, on } from '@ngrx/store';
import * as ReceivingsActions from '../actions/receivings.actions';

export const receivingsFeatureKey = 'receivings';

export interface State {
  currentPage: number,
  receivings: any,
  receivingsPath: any,
  filterType: string,
  filterID: number
  total: number,
  query: string,
  isLoading: boolean,
  sortType: string,
  direction: string,
  receiving: any,
  selected: any,
  isMasterChecked: boolean,
  barcodes: any[]

  /**
   * Errors
   */
  duplicateBarcode: boolean
}

export const initialState: State = {
  currentPage: 0,
  receivings: [],
  receivingsPath: null,
  receiving: null,
  filterType: null,
  total: 0,
  filterID: 0,
  query: "",
  isLoading: true,
  sortType: null,
  direction: null,
  selected: [],
  isMasterChecked: false,
  barcodes: null,
  duplicateBarcode: false
};

export const reducer = createReducer(
  initialState,

  on(ReceivingsActions.loadReceivings, state => state),
  on(ReceivingsActions.loadReceivingsSuccess, (state, action) => ({
    ...state,
    receivings: [...action.receivings],
    total: action.total,
    isLoading: false
  })),
  on(ReceivingsActions.loadReceivingsFailure, (state, action) => state),
  on(ReceivingsActions.updateReceiving, state => state),
  on(ReceivingsActions.updateReceivingSuccess, (state, { receiving }) => ({
    ...state,
    receivings: state.receivings.map(item => {
      if(receiving!=null && receiving.productMovementHistoryID!=null && item.productMovementHistoryID == receiving.productMovementHistoryID){
        return receiving;
      }else{
        return item
      }
    }),
    receiving: receiving,
    isLoading: false
  })),
  on(ReceivingsActions.loadReceiving, state => state),
  on(ReceivingsActions.loadReceivingSuccess, (state, action) => ({
    ...state,
    receiving: action.receiving,
    isLoading: false
  })),
  on(ReceivingsActions.loadReceivingFailure, (state, action) => state),
  on(ReceivingsActions.filterByCategory, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReceivingsActions.filterByCategorySuccess, (state, action) => ({
    ...state,
    receivings: action.receivings,
    total: action.total,
    isLoading: false
  })),
  on(ReceivingsActions.filterByCategoryFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(ReceivingsActions.filterByArea, (state, action )=> ({
    ...state,
    sortType: action.active,
    direction: action.direction,
    isLoading: true
  })),
  on(ReceivingsActions.filterByAreaSuccess, (state, action) => ({
    ...state,
    receivings: action.receivings,
    total: action.total,
    isLoading: false
  })),
  on(ReceivingsActions.filterByAreaFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(ReceivingsActions.deleteReceiving, (state, action) => ({
    ...state,
  })),
  on(ReceivingsActions.deleteReceivingSuccess, (state, action) => ({
    ...state,
    receivings: state.receivings.filter(receiving => receiving.productMovementHistoryID != action.productMovementHistoryID),
  })),
  on(ReceivingsActions.deleteReceivingsSuccess, (state, action) => ({
    ...state,
    isMasterChecked: false
  })),
  on(ReceivingsActions.saveReceiving, state => state),
  on(ReceivingsActions.saveReceivingSuccess, (state, action) => ({
    ...state,
    receivings: [action.receiving, ...state.receivings],
    total: state.total +  1
  })),
  on(ReceivingsActions.saveReceivingFailure, (state, action) => state),

  on(ReceivingsActions.search, (state, action) => ({
    ...state,
    query: action.query,
    isLoading: true
  })),
  on(ReceivingsActions.searchSuccess, (state, action) => ({
    ...state,
    receivings: action.receivings,
    total: action.total,
    isLoading: false
  })),
  on(ReceivingsActions.searchFailure, (state, action) => ({
    ...state,
    error: action.error,
  })),
  on(ReceivingsActions.incrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage + 1
  })),
  on(ReceivingsActions.decrementPage, (state, action) => ({ 
    ...state,
    currentPage: state.currentPage - 1
  })),
  on(ReceivingsActions.resetPage, (state, action) => ({ 
    ...state,
    currentPage: 0
  })),
  on(ReceivingsActions.incrementPage, (state, action) => ({ 
    ...state,
  })),
  on(ReceivingsActions.incrementPageSuccess, (state, action) => ({ 
    ...state,
    currentPage: action.currentPage
  })),
  on(ReceivingsActions.setFilterType, (state, action) => ({
    ...state,
    filterType: action.filterType,
    filterID: action.filterID
  })),
  on(ReceivingsActions.setSelected, (state, action) => ({
    ...state,
    selected: action.selected,
    isMasterChecked: true
  })),
  on(ReceivingsActions.setDeselected, (state) => ({
    ...state,
    selected: [],
    isMasterChecked: false
  })),
  on(ReceivingsActions.setSort, (state, action) => ({
    ...state,
    sortType: action.sort,
    direction: action.direction
  })),
  on(ReceivingsActions.resetReceiving, (state, action) => ({
    ...state,
    receiving: null
  })),
  on(ReceivingsActions.resetReceivings, (state, action) => ({
    ...state,
    receivings: [],
    isLoading: true
  })),
  on(ReceivingsActions.resetFilter, (state, action) => ({
    ...state,
    filterType: null,
    filterID: null
  })),
  on(ReceivingsActions.createBarcode, (state, action) => ({
    ...state,
    barcodes: [...state.barcodes, {
      barcodeData: action.barcodeData
    }],
    duplicateBarcode: false
  })),
  on(ReceivingsActions.setBarcodes, (state, action) => ({
    ...state,
    barcodes: action.barcodes
  })),
  on(ReceivingsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(ReceivingsActions.createBarcodeFailure, (state, action) => ({
    ...state,
    duplicateBarcode: true
  })),
  on(ReceivingsActions.setSelectedBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes?.map((item, index) => {
      if(index != action.index){
        item.selected = false;
      }else{
        item.selected = true;
      }
      return item;
    })
  })),
  on(ReceivingsActions.deleteBarcode, (state, action) => ({
    ...state,
    barcodes: state.barcodes.filter(item => item.barcodeID != action.barcodeID)
  })),
  on(ReceivingsActions.setIsLoading, (state, action) => ({
    ...state,
    isLoading: action.isLoading
  })),

);
